import { backendApi, Result } from "./backendApi";

export interface RegionModel {
  id?: number;
  region?: string;
  english?: string;
  dutch?: string;
  german?: string;
  french?: string;
  spanish?: string;
  portugues?: string;
  italian?: string;
  polish?: string;
  czech?: string;
  swedish?: string;
  danish?: string;
  norwegian?: string;
  finnish?: string;
  hungarian?: string;
  croatian?: string;
  hebrew?: string;
  slovene?: string;
  russian?: string;
  arabic?: string;
  ukrainian?: string;
}

class GetRegionsRequest {}

class GetRegionsResponse {
  regions?: RegionModel[];
}

export const regionApi = {
  async GetRegions(): Promise<Result<RegionModel[]>> {
    let response = await backendApi.sendAndGetResponseAsync<GetRegionsResponse>(
      "GetRegions",
      new GetRegionsRequest(),
    );

    if (response.ok) {
      return { ok: true, value: response.value.regions ?? [] };
    }

    return response;
  },
};
